
import {useEffect, useState} from 'react';
import {gql, useMutation} from '@apollo/client';

const setPublic = gql`
mutation ($cache: ID!, $desired: Boolean) {
	reports {
		updates(cache: $cache) {
			public(desired: $desired)
		}
	}
}`;

interface Vars {
	cache: string
	desired?: boolean
}

interface Result {
	reports: {
		updates?: {
			public: boolean
		}
	}
}

export type Sharing = {
	cache: string
	enabled: boolean
	toggle: () => void
	loading: boolean
}

export const useSharing = (cache: string): Sharing => {
	const [enabled, set] = useState<boolean>(false);
	const [update, {loading}]= useMutation<Result, Vars>(setPublic, {
		onCompleted: (data) => {
			const value = data.reports.updates?.public;
			if (value !== undefined && value !== enabled) {
				set(value);
			}
		},
	});

	useEffect(() => {
		if (cache) {
			update({variables: {cache}});
		}
	}, [cache]);

	return {
		cache,
		enabled,
		toggle: () => {
			update({
				variables: {
					cache,
					desired: !enabled,
				}
			});
		},
		loading,
	};
};
